export default {
  title: 'Change your password',
  subtitle: 'Secure your account with a strong password',
  placeholder: {
    currentPassword: 'Enter your current password',
    newPassword: 'Enter a new password',
    repeatNewPassword: 'Repeat a new password',
  },
  submitButton: 'Confirm',
};
